import { computed } from 'mobx';

export default class TicketActionModel {
  id;
  store;

  constructor(store, ticketAction) {
    this.store = store;
    this.id = +ticketAction.id;
    this.caption = ticketAction.caption;
    this.description = ticketAction.description;
    this.color = ticketAction.color;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      caption: this.caption,
      description: this.description,
      color: this.color,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.caption = json.caption;
    this.description = json.description;
    this.color = json.color;
  }
}



// WEBPACK FOOTER //
// ./src/models/Maintenance/Ticket/TicketActionModel.js